import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import DesignUtils from "../../../utils/DesignUtils";

import styles from "./drawer.module.scss";
import { useContext } from "react";
import { AuthContext } from "../../../contexts/auth";
import { AdminList } from "./adminList";
import { NonAdminList } from "./nonAdminList";

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "absolute",
    whiteSpace: "nowrap",
    width: DesignUtils.getDrawerWith(),
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(10),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(10),
      },
    }),
  },
}));

export const DashboardDrawer = ({ open, toggleDrawer }) => {
  const { isAdmin, operations } = useContext(AuthContext);
  //const { typeOperation } = useContext(AuthContext);
  const userType = isAdmin();
  const operationsUser = operations();
  return (
    <Drawer
      PaperProps={{
        sx: {
          backgroundColor: "rgb(0, 28, 47)",
          boxShadow: "unset",
          border: "1px solid rgba(0, 28, 47, 0.65)",
          display: "flex",
          flexDirection: "column",
          paddingBottom: 2,
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(255, 255, 255, 0.3)",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.6)",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        },
      }}
      variant="permanent"
      open={open}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: [1],
        }}
      >
        <IconButton onClick={toggleDrawer}>
          <ChevronLeftRoundedIcon className={styles.drawerToggleIcon} />
        </IconButton>
      </Toolbar>
      {userType === "SystemAdmin" ? (
        <AdminList toggleDrawer={toggleDrawer} openDrawer={open} />
      )
        // :
        //   typeOperation() === "SALA1" ||
        //     typeOperation() === "SALA2" ||
        //     typeOperation() === "SALA3" ||
        //     typeOperation() === "SALA4" ? (
        //     <NonAdminListFarm toggleDrawer={toggleDrawer} typeUser={userType}></NonAdminListFarm>
        //   ) 
        : (

          <NonAdminList toggleDrawer={toggleDrawer} typeUser={userType} operations={operationsUser} />
        )}
    </Drawer>
  );
};

